<template>
  <div class="d-flex justify-content-center mt-5">
    <div class="col col-6">
      <GenericTabsLayout :tabsNumber="2">
        <template #page-header>
          <h5 class="mt-1 mb-0">
            Admin actions
          </h5>
        </template>
        <template #tab-1-header>
          Admin Portal
        </template>
        <template #tab-1-content>
          <div
            v-if="initialized"
            class="upload-container p-3"
          >
            <div
              v-for="serviceStatus in adminPortalServices"
              :key="serviceStatus.serviceName"
            >
              <h5>Service name: {{ serviceStatus.serviceName }}</h5>
              <br />
              <div class="form-check form-switch">
                <input
                  v-if="services[serviceStatus.serviceName]"
                  id="flexSwitchCheckDefault"
                  v-model="services[serviceStatus.serviceName].hasErrors"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  @change="showServiceStatusConfirmationModal(serviceStatus.serviceName)"
                />
                <label
                  class="form-check-label"
                  for="flexSwitchCheckDefault"
                >
                  Enable/disable admin panel error notification for "{{ serviceStatus.serviceName }}" service
                </label>
              </div>
              <hr />
              <TextInput
                v-if="services[serviceStatus.serviceName]"
                v-model="services[serviceStatus.serviceName].notificationMessage"
                :errors="v$.services[serviceStatus.serviceName].notificationMessage.$errors"
                label="Notification Message"
                description="Put here the message you want to show users"
                @blur="v$.services[serviceStatus.serviceName].notificationMessage.$touch"
              />
              <button
                class="btn btn-sm btn-primary"
                :disabled="v$.services[serviceStatus.serviceName].notificationMessage.$errors?.length > 0"
                @click="showNotificationMessageConfirmationModal(serviceStatus.serviceName)"
              >
                Update notification message
              </button>
              <hr />
            </div>
            <h5>Alerts to clients</h5>
            <div class="form-check form-switch">
              <input
                v-if="alertsToClientsStatus"
                v-model="alertsToClientsStatus.status"
                class="form-check-input"
                type="checkbox"
                role="switch"
                @change="showAlertsToClientsStatusConfirmationModal()"
              />
              <label
                class="form-check-label"
                for="flexSwitchCheckDefault"
              > Enable/disable alerts to clients </label>
            </div>
            <hr />
            <h5>Show forecast upload via AI</h5>
            <div class="form-check form-switch">
              <input
                v-if="showForecastAiStatus"
                v-model="showForecastAiStatus.status"
                class="form-check-input"
                type="checkbox"
                role="switch"
                @change="showForecastAiStatusConfirmationModal()"
              />
              <label
                class="form-check-label"
                for="flexSwitchCheckDefault"
              >
                Enable/disable forecast upload via AI tab
              </label>
            </div>
          </div>
          <Spinner v-else />
        </template>
        <template #tab-2-header>
          Customer Portal
        </template>
        <template #tab-2-content>
          <div
            v-if="initialized"
            class="upload-container p-3"
          >
            <div
              v-for="serviceStatus in customerPortalServices"
              :key="serviceStatus.serviceName"
            >
              <h5>Service name: {{ serviceStatus.serviceName }}</h5>
              <br />
              <div class="form-check form-switch">
                <input
                  v-if="services[serviceStatus.serviceName]"
                  id="flexSwitchCheckDefault"
                  v-model="services[serviceStatus.serviceName].hasErrors"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  @change="showServiceStatusConfirmationModal(serviceStatus.serviceName)"
                />
                <label
                  class="form-check-label"
                  for="flexSwitchCheckDefault"
                >
                  Enable/disable customer portal error notification for "{{ serviceStatus.serviceName }}" service
                </label>
              </div>
              <hr />
              <TextInput
                v-if="services[serviceStatus.serviceName]"
                v-model="services[serviceStatus.serviceName].notificationMessage"
                :errors="v$.services[serviceStatus.serviceName].notificationMessage.$errors"
                label="Notification Message"
                description="Put here the message you want to show users"
                @blur="v$.services[serviceStatus.serviceName].notificationMessage.$touch"
              />
              <button
                class="btn btn-sm btn-primary"
                :disabled="v$.services[serviceStatus.serviceName].notificationMessage.$errors?.length > 0"
                @click="showNotificationMessageConfirmationModal(serviceStatus.serviceName)"
              >
                Update notification message
              </button>
              <hr />
            </div>
            <div
              v-for="customerPortalTabStatus in customerPortalTabStatuses"
              :key="customerPortalTabStatus?.id"
            >
              <h5>Show {{ customerPortalTabStatus?.tabName }} tab in customer portal</h5>
              <div class="form-check form-switch">
                <input
                  v-if="customerPortalTabStatus"
                  v-model="customerPortalTabStatus.isVisible"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  @change="showCustomerPortalTabStatusConfirmationModal(customerPortalTabStatus)"
                />
                <label
                  class="form-check-label"
                  for="flexSwitchCheckDefault"
                >
                  Enable/disable {{ customerPortalTabStatus?.tabName }} tab
                </label>
              </div>
              <hr />
            </div>
            <h5>Editable text blocks</h5>
            <TextArea
              v-model="dashboardsAdditionalNotesLocal.text"
              label="Dashboards Additional Notes"
              description="Additional notes to display on the dashboards page"
              :rows="5"
            />
            <button
              class="btn btn-sm btn-primary"
              @click="showFooterTextConfirmationModal()"
            >
              Update additional notes
            </button>
            <Spinner v-if="!initialized" />
          </div>
          <Spinner v-else />
        </template>
      </GenericTabsLayout>
    </div>
  </div>
  <AdminActionsServiceStatusConfirmation
    ref="change-notification-mode-confirmation"
    :onCancelHandler="cancelEdit"
    :onConfirmHandler="saveErrorsStatusHandler"
    :serviceName="processedServiceName"
  />
  <AdminActionsNotificationMessageConfirmation
    ref="change-notification-message-confirmation"
    :onCancelHandler="cancelEdit"
    :onConfirmHandler="saveNotificationMessageHandler"
    :displayedMessage="services[processedServiceName] ? services[processedServiceName].notificationMessage : ''"
    :serviceName="processedServiceName"
  />
  <AdminActionsAlertsToClientsConfirmation
    ref="change-alerts-to-clients-confirmation"
    :onCancelHandler="cancelEdit"
    :onConfirmHandler="saveAlertsToClientsStatusHandler"
  />
  <ConfirmationModal
    ref="change-show-forecast-ai-confirmation"
    :onCancelHandler="cancelEdit"
    :onConfirmHandler="saveShowForecastAiStatusHandler"
  >
    <template #content>
      <div
        class="alert alert-warning"
        role="alert"
      >
        <h6>
          <i class="bi bi-exclamation-triangle" />
          Do You really want to change show forecast AI status?
        </h6>
      </div>
    </template>
  </ConfirmationModal>
  <ConfirmationModal
    ref="update-customer-portal-tab-status-confirmation"
    :onCancelHandler="cancelEdit"
    :onConfirmHandler="saveCustomerPortalTabStatusHandler"
  >
    <template #content>
      <div
        class="alert alert-warning"
        role="alert"
      >
        <h6>
          <i class="bi bi-exclamation-triangle" />
          Do You really want to change visibility of {{ selectedCustomerPortalTabStatus?.tabName }} tab?
        </h6>
      </div>
    </template>
  </ConfirmationModal>
  <ConfirmationModal
    ref="update-customer-portal-footer-text-confirmation"
    :onCancelHandler="cancelEdit"
    :onConfirmHandler="saveFooterTextHandler"
  >
    <template #content>
      <div
        class="alert alert-warning"
        role="alert"
      >
        <h6>
          <i class="bi bi-exclamation-triangle" />
          Do You really want to update the additional notes?
        </h6>
        <strong>Preview:</strong>
        <div class="border p-2 mt-2">
          {{ dashboardsAdditionalNotesLocal.text || "(empty)" }}
        </div>
      </div>
    </template>
  </ConfirmationModal>
</template>
<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import Spinner from '@/components/common/Spinner';
import TextInput from '@/components/common/TextInput';
import TextArea from '@/components/common/TextArea';
import GenericTabsLayout from '@/components/Layouts/GenericTabsLayout.vue';
import { maxLength } from '@vuelidate/validators';
import AdminActionsServiceStatusConfirmation from '@/components/AdminActions/AdminActionsServiceStatusConfirmation';
import AdminActionsNotificationMessageConfirmation from '@/components/AdminActions/AdminActionsNotificationMessageConfirmation';
import AdminActionsAlertsToClientsConfirmation from '@/components/AdminActions/AdminActionsAlertsToClientsConfirmation';
import ConfirmationModal from '@/components/common/ConfirmationModal.vue';

export default {
  components: {
    ConfirmationModal,
    AdminActionsNotificationMessageConfirmation,
    Spinner,
    TextInput,
    TextArea,
    GenericTabsLayout,
    AdminActionsServiceStatusConfirmation,
    AdminActionsAlertsToClientsConfirmation,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      initialized: false,
      generalNotificationsEnabled: false,
      services: {},
      alertsToClientsStatus: null,
      serviceStatusConfirmationModal: null,
      notificationMessageConfirmationModal: null,
      processedServiceName: null,
      alertsToClientsConfirmationModal: null,
      showForecastAiStatus: null,
      showForecastAiConfirmationModal: null,
      customerPortalTabStatusConfirmationModal: null,
      selectedCustomerPortalTabStatus: null,
      dashboardsAdditionalNotesConfirmationModal: null,
      dashboardsAdditionalNotesLocal: {
        id: null,
        text: '',
      },
    };
  },
  validations() {
    const serviceNames = _.keys(this.services);

    return {
      services: _.reduce(
        serviceNames,
        (acc, serviceName) => {
          if (serviceName) {
            acc[serviceName] = {
              hasErrors: {},
              notificationMessage: {
                minLength: maxLength(180),
              },
            };
          }
          return acc;
        },
        {}
      ),
    };
  },
  computed: {
    ...mapGetters({
      serviceStatuses: 'adminActions/serviceStatuses',
      customerPortalTabStatuses: 'customerPortalSettings/customerPortalTabStatuses',
      dashboardsAdditionalNotes: 'customerPortalSettings/dashboardsAdditionalNotes',
    }),
    adminPortalServices() {
      return this.serviceStatuses.filter((service) => service.serviceName.startsWith('admin-panel'));
    },
    customerPortalServices() {
      return this.serviceStatuses.filter((service) => !service.serviceName.startsWith('admin-panel'));
    },
  },
  watch: {
    footerText: {
      handler(newVal) {
        if (newVal) {
          this.dashboardsAdditionalNotesLocal.text = newVal.textContent || '';
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    this.serviceStatusConfirmationModal = this.$refs['change-notification-mode-confirmation'].confirmationModal;
    this.notificationMessageConfirmationModal =
      this.$refs['change-notification-message-confirmation'].confirmationModal;
    this.alertsToClientsConfirmationModal = this.$refs['change-alerts-to-clients-confirmation'].confirmationModal;
    this.showForecastAiConfirmationModal = this.$refs['change-show-forecast-ai-confirmation'].confirmationModal;
    this.customerPortalTabStatusConfirmationModal =
      this.$refs['update-customer-portal-tab-status-confirmation'].confirmationModal;
    this.dashboardsAdditionalNotesConfirmationModal =
      this.$refs['update-customer-portal-footer-text-confirmation'].confirmationModal;
    this.initialized = false;
    await this.init();
  },
  methods: {
    ...mapActions({
      changeServiceStatus: 'adminActions/changeServiceStatus',
      changeServiceNotificationMessage: 'adminActions/changeServiceNotificationMessage',
      fetchServiceStatuses: 'adminActions/fetchServiceStatuses',
      fetchAlertsToClientsStatus: 'forecast/fetchAlertsToClients',
      changeAlertsToClientsStatus: 'forecast/changeAlertsToClients',
      changeShowForecastAiStatus: 'forecast/changeShowForecastAiStatus',
      fetchShowForecastAiStatus: 'forecast/fetchShowForecastAiStatus',
      fetchCustomerPortalTabStatuses: 'customerPortalSettings/fetchCustomerPortalTabStatuses',
      updateCustomerPortalTabStatus: 'customerPortalSettings/updateCustomerPortalTabStatus',
      fetchCPDashboardsAdditionalNotes: 'customerPortalSettings/fetchCPDashboardsAdditionalNotes',
      updateCPDashboardsAdditionalNotes: 'customerPortalSettings/updateCPTextBlock',
    }),
    async saveCustomerPortalTabStatusHandler() {
      await this.updateCustomerPortalTabStatus(this.selectedCustomerPortalTabStatus);
      await this.fetchCustomerPortalTabStatuses();
      this.selectedCustomerPortalTabStatus = null;
    },
    showCustomerPortalTabStatusConfirmationModal(customerPortalTabStatus) {
      this.selectedCustomerPortalTabStatus = customerPortalTabStatus;
      this.customerPortalTabStatusConfirmationModal.show();
    },
    showFooterTextConfirmationModal() {
      this.dashboardsAdditionalNotesConfirmationModal.show();
    },
    async saveFooterTextHandler() {
      try {
        const textBlockDto = {
          id: this.dashboardsAdditionalNotesLocal?.id || null,
          blockName: 'dashboard-additional-notes',
          textContent: this.dashboardsAdditionalNotesLocal.text,
        };
        await this.updateCPDashboardsAdditionalNotes(textBlockDto);
        await this.fetchCPDashboardsAdditionalNotes();
        this.$toast.success('Additional notes updated successfully');
      } catch (e) {
        console.log(e);
        this.$toast.error('Failed to update additional notes.\nPlease try again or contact the administrator.');
      }
    },
    showServiceStatusConfirmationModal(serviceName) {
      this.processedServiceName = serviceName;
      this.serviceStatusConfirmationModal.show();
    },
    showAlertsToClientsStatusConfirmationModal() {
      this.alertsToClientsConfirmationModal.show();
    },
    async showNotificationMessageConfirmationModal(serviceName) {
      this.processedServiceName = serviceName;
      this.notificationMessageConfirmationModal.show();
    },
    showForecastAiStatusConfirmationModal() {
      this.showForecastAiConfirmationModal.show();
    },
    async cancelEdit() {
      this.processedServiceName = null;
      this.initialized = false;
      await this.init();
    },
    async saveErrorsStatusHandler() {
      try {
        await this.changeServiceStatus({
          serviceName: this.processedServiceName,
          hasErrors: this.services[this.processedServiceName].hasErrors,
        });
      } catch (e) {
        console.log(e);
      }
      this.processedServiceName = null;
      await this.init();
    },
    async saveNotificationMessageHandler() {
      try {
        await this.changeServiceNotificationMessage({
          serviceName: this.processedServiceName,
          notificationMessage: this.services[this.processedServiceName].notificationMessage,
        });
      } catch (e) {
        console.log(e);
      }
      this.processedServiceName = null;
      this.initialized = false;
      await this.init();
    },
    async saveAlertsToClientsStatusHandler() {
      try {
        await this.changeAlertsToClientsStatus({
          status: this.alertsToClientsStatus.status,
        });
      } catch (e) {
        console.log(e);
        this.$toast.error('Failed to toggle switch.\nPlease try again or contact the administrator.');
      }
    },
    async saveShowForecastAiStatusHandler() {
      try {
        await this.changeShowForecastAiStatus({
          status: this.showForecastAiStatus.status,
        });
      } catch (e) {
        console.log(e);
        this.$toast.error('Failed to toggle switch.\nPlease try again or contact the administrator.');
      }
    },
    async init() {
      await this.fetchServiceStatuses();
      _.forEach(this.serviceStatuses, (serviceStatus) => {
        this.services[serviceStatus.serviceName] = {
          hasErrors: serviceStatus.hasErrors,
          notificationMessage: serviceStatus.notificationMessage,
        };
      });
      this.alertsToClientsStatus = await this.fetchAlertsToClientsStatus();
      this.showForecastAiStatus = await this.fetchShowForecastAiStatus();
      await this.fetchCustomerPortalTabStatuses();
      await this.fetchCPDashboardsAdditionalNotes();
      this.dashboardsAdditionalNotesLocal.id = this.dashboardsAdditionalNotes.id;
      this.dashboardsAdditionalNotesLocal.text = this.dashboardsAdditionalNotes.textContent || '';
      this.initialized = true;
    },
  },
};
</script>
